import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { RowSelection$1, Table, Row, Cell, Column, FilterType } from "./Table.fs.js";
import { map, length, isEmpty, empty, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { adminContent, ByCell, dateTimeCell } from "./Prelude.fs.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { empty as empty_1, singleton, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { count, many } from "../Api/ProductionUnitTypes.fs.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { DomainEntity } from "../ClientTypes.fs.js";
import { Components_Delete } from "../Modals/Modal.fs.js";
import { Create } from "../Modals/ProductionUnitType.fs.js";

function nameParam(name) {
    if (isNullOrWhiteSpace(name)) {
        return new FSharpResult$2(1, ["name"]);
    }
    else {
        return new FSharpResult$2(0, [["name", name]]);
    }
}

const columns = ofArray([new Column("name", "Name", new FilterType(0, [nameParam])), new Column("lastModifiedOn", "Last Modified", undefined), new Column("lastModifiedBy", "Last Modified By", undefined)]);

function rowRender(projectId, productionUnitType) {
    return new Row(productionUnitType.Id, ofArray([new Cell("name", productionUnitType.Name), new Cell("lastModifiedOn", dateTimeCell(productionUnitType.LastModified)), new Cell("lastModifiedBy", createElement(ByCell, {
        projectId: projectId,
        by: productionUnitType.LastModifiedBy,
    }))]));
}

export function ProductionUnitTypes(productionUnitTypesInputProps) {
    let actions, modules;
    const projectId = productionUnitTypesInputProps.projectId;
    const patternInput = reactApi.useState(undefined);
    const setAction = patternInput[1];
    const action = patternInput[0];
    const patternInput_1 = reactApi.useState(empty());
    const selectedProductionUnitTypes = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const showDeleted = patternInput_2[0];
    const patternInput_3 = reactApi.useState("");
    const patternInput_4 = reactApi.useState(empty());
    const close = reactApi.useCallback((hasChanges) => {
        let copyOfStruct;
        setAction(undefined);
        if (hasChanges) {
            patternInput_3[1]((copyOfStruct = utcNow(), toString(copyOfStruct)));
        }
    }, []);
    const table = createElement(Table, {
        name: "ProductionUnitTypes",
        columns: columns,
        initialFilters: toList(delay(() => (showDeleted ? singleton(["deleted", ""]) : empty_1()))),
        onFiltersChange: patternInput_4[1],
        fetchData: (productionUnitTypeParams) => many(projectId, empty(), productionUnitTypeParams),
        fetchCount: (productionUnitTypeParams_1) => count(projectId, productionUnitTypeParams_1),
        rowRender: (productionUnitType) => rowRender(projectId, productionUnitType),
        refresh: patternInput_3[0],
        rowSelection: new RowSelection$1(2, [patternInput_1[1]]),
    });
    const isNotEmpty = !isEmpty(selectedProductionUnitTypes);
    const isMoreThan1 = length(selectedProductionUnitTypes) !== 1;
    return adminContent(ofArray([createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["children", showDeleted ? "Hide Deleted" : "Show Deleted"], ["onClick", (_arg) => {
        patternInput_2[1](!showDeleted);
    }]])))), createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Create"], ["onClick", (_arg_1) => {
        setAction("create");
    }], ["disabled", isNotEmpty ? true : showDeleted]])))), createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "Delete"], ["onClick", (_arg_2) => {
        setAction("delete");
    }], ["disabled", isEmpty(selectedProductionUnitTypes) ? true : showDeleted]]))))]), table, (action != null) ? ((actions = action, (actions === "delete") ? ((modules = map((Item) => (new DomainEntity(4, [Item])), selectedProductionUnitTypes), createElement(Components_Delete, {
        projectId: projectId,
        entities: modules,
        close: close,
    }))) : createElement(Create, {
        projectId: projectId,
        close: close,
    }))) : undefined);
}

